const getButtonVariant = (item)=>{
    var ref, ref1, ref2;
    return ((ref = item.parameters) === null || ref === void 0 ? void 0 : ref.buttonVariant) && [
        'solid',
        'ghost',
        'outline'
    ].indexOf((ref1 = item.parameters) === null || ref1 === void 0 ? void 0 : ref1.buttonVariant) > -1 ? (ref2 = item.parameters) === null || ref2 === void 0 ? void 0 : ref2.buttonVariant : 'solid';
};
const getButtonColor = (item)=>{
    var ref, ref3, ref4;
    return ((ref = item.parameters) === null || ref === void 0 ? void 0 : ref.buttonColor) && [
        'primary',
        'secondary'
    ].indexOf((ref3 = item.parameters) === null || ref3 === void 0 ? void 0 : ref3.buttonColor) > -1 ? (ref4 = item.parameters) === null || ref4 === void 0 ? void 0 : ref4.buttonColor : 'primary';
};

export { getButtonColor, getButtonVariant };
//# sourceMappingURL=helpers.js.map
